import { v4 as uuid } from "uuid";
import { ACTIVE_KEY, SHARED_KEY } from "./sharedComputer";

// What the chat leaves in this browser, cleared at sign-out so the next person on a shared
// computer finds nothing of the last student's (F5). Older builds wrote some of these keys
// (answers so far, the chat with name/age/sex); current code no longer writes them, but
// computers that ran those builds still have them.
const PREFIXES = ["assessment_session_", "force_new_", "chatbot_state_", "anna.nextTalk"];
// ...plus the "Shared computer" choice, which lasts for one sign-in (utils/sharedComputer.js)
const KEYS = ["max_chatbot_starts", SHARED_KEY, ACTIVE_KEY];

// The Dialogflow session id the chat keeps in a cookie (Chatbot.js reads it with
// universal-cookie, which re-reads document.cookie on every get).
export const CHAT_ID_COOKIE = "userId";

const dropKeys = (storage) => {
  if (!storage) return;
  const doomed = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key && (KEYS.includes(key) || PREFIXES.some((p) => key.startsWith(p)))) doomed.push(key);
  }
  doomed.forEach((key) => storage.removeItem(key));
};

export const clearChatId = () => {
  try {
    document.cookie = `${CHAT_ID_COOKIE}=; path=/; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  } catch {
    // No cookies here; nothing to clear.
  }
};

// Each sign-in gets its own chat id, so the chat server never joins two students' chats.
export const startFreshChatId = () => {
  try {
    document.cookie = `${CHAT_ID_COOKIE}=${uuid()}; path=/`;
  } catch {
    // No cookies: Chatbot.js makes one when it needs it.
  }
};

// "Someone has signed in on this device before" (N7): the homepage opens the sign-in box by
// itself only then, so a first-timer isn't greeted with it. No name or id, just a yes;
// sign-out keeps it.
const SIGNED_IN_HERE_KEY = "anna.signedInHere";
export const markSignedInHere = () => {
  try {
    localStorage.setItem(SIGNED_IN_HERE_KEY, "1");
  } catch {
    // Storage blocked: the homepage just won't open sign-in by itself
  }
};
export const hasSignedInHere = () => {
  try {
    return localStorage.getItem(SIGNED_IN_HERE_KEY) === "1";
  } catch {
    return false;
  }
};

export const clearStudentTraces = () => {
  try {
    dropKeys(window.localStorage);
  } catch {
    // Storage can be blocked; nothing was kept then.
  }
  try {
    dropKeys(window.sessionStorage);
  } catch {
    // Same as above.
  }
  clearChatId();
};
